import BaseService from "./geral/BaseService";

const base = "OrcamentoWebCalcImport";

export default class OrcamentoImportService extends BaseService {
  constructor() {
    super(base);
  }

  /* GerarBoleto(codTipo, valorTipo, refCliente, send) {
    return super.httpPost(`${base}/GerarBoleto?codigoTipo=${codTipo}&valorTipo=${valorTipo}&refCliente=${refCliente}`, send)
  } */

  ListaBl() {
    return super.httpGet(`${base}/ListarBL`);
  }
  ListaDi() {
    return super.httpGet(`${base}/ListarDI`);
  }
  ListarMoedas() {
    return super.httpGet(`${base}/ListarMoedas`);
  }
  Detalhe(orcamentoId = "") {
    return super.httpGet(`${base}/Detalhe/${orcamentoId}`);
  }
  ExibirOs(guid = "", dataFimServ = "") {
    const hasDataFimServ = dataFimServ != null && dataFimServ !== "";
    const queryString = hasDataFimServ
      ? `?dtFimServ=${encodeURIComponent(dataFimServ)}`
      : "";
    return super.httpGet(`${base}/ExibirOS/${guid}${queryString}`);
  }
  DemonstrativoArmazenagem(armId = "", maxDias = "") {
    return super.httpGet(
      `${base}/DemonstrativoArmazenagem?armCalcId=${armId}&maxDias=${maxDias}`
    );
  }
  ListarServicos(blId = "") {
    return super.httpGet(`${base}/ListarServicos?blId=${blId}`);
  }
  RecuperarCif(blId = "", moeda = "") {
    return super.httpGet(
      `${base}/RecuperarValorCIF/${blId}?moedaSelec=${moeda}`
    );
  }
  GerarDemonstrativo(blId = "", dataFimServ = "", valorCif = "", guid = "") {
    const fetchURL = `/OrcamentoWebConsulta/Demonstrativo?documento=${blId}&dtFimServ=${dataFimServ}&valorCif=${valorCif}&guid=${guid}`
    return super.httpGet(fetchURL, true);
  }

  Calcular(
    dataFim = "",
    docBl = "",
    docDi = "",
    moeda = "",
    valorCif = "",
    serv = {}
  ) {
    return super.httpPost(
      `${base}/Calcular?dataFimServ=${dataFim}&documentoIdBl=${docBl}&documentoIdDi=${docDi}&moedaSelec=${moeda}&valorCif=${valorCif}`,
      serv
    );
  }
  GerarBoletoRig(
    numBl,
    valorCif,
    diaPorta,
    incRetirada = false,
    dataRetirada = "",
    desova = false,
    saidaBarc = false,
    refCliente = "",
    bolData = []
  ) {
    return super.httpPost(
      `${base}/GerarBoletoRig?numeroBlOuDi=${numBl}&valorCif=${valorCif}&pagarDiaDePorta=${diaPorta}&incDataRetirada=${incRetirada}&dataRetirada=${dataRetirada}&ehDesovaHouse=${desova}&ehSaidaBarc=${saidaBarc}&refCliente=${refCliente}`,
      bolData
    );
  }
  GerarBoletoSsa(
    guid = "",
    dataServ = "",
    isDatRet = false,
    diaPorta = false,
    numBl = "",
    numDi = "",
    refCliente = "",
    serv
  ) {
    return super.httpPost(
      `${base}/GerarBoletoSsa?guid=${guid}&dataServ=${dataServ}&incluirDatRetCalcValArmz=${isDatRet}&pagarDiaPorta=${diaPorta}&numeroBl=${numBl}&numeroDi=${numDi}&refCliente=${refCliente}`,
      serv
    );
  }
  PesquisaRig(
    numBl = "",
    valorCif = "",
    diaPorta = false,
    incRetirada = false,
    dataRetirada = "",
    desova = false,
    saidaBarc = false
  ) {
    return super.httpGet(
      `${base}/ProcessarRig?numeroBlOuDi=${numBl}&valorCif=${valorCif}&pagarDiaDePorta=${diaPorta}&incDataRetirada=${incRetirada}&dataRetirada=${dataRetirada}&ehDesovaHouse=${desova}&ehSaidaBarc=${saidaBarc}`
    );
  }
  PesquisaSsa(numBl = "", numDi = "") {
    return super.httpGet(
      `${base}/ProcessarSsa?numeroBl=${numBl}&numeroDi=${numDi}`
    );
  }

  GerarPixRig(
    numBl,
    valorCif,
    diaPorta,
    incRetirada = false,
    dataRetirada = "",
    desova = false,
    saidaBarc = false,
    refCliente = "",
    bolData = []
  ) {
    return super.httpPost(
      `${base}/GerarPixRig?numeroBlOuDi=${numBl}&valorCif=${valorCif}&pagarDiaDePorta=${diaPorta}&incDataRetirada=${incRetirada}&dataRetirada=${dataRetirada}&ehDesovaHouse=${desova}&ehSaidaBarc=${saidaBarc}&refCliente=${refCliente}`,
      bolData
    );
  }

  GerarPixSsa(
    guid = "",
    dataServ = "",
    isDatRet = false,
    diaPorta = false,
    numBl = "",
    numDi = "",
    refCliente = "",
    serv
  ) {
    return super.httpPost(
      `${base}/GerarPixSsa?guid=${guid}&dataServ=${dataServ}&incluirDatRetCalcValArmz=${isDatRet}&pagarDiaPorta=${diaPorta}&numeroBl=${numBl}&numeroDi=${numDi}&refCliente=${refCliente}`,
      serv
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/OrcamentoImportService.js